import { jsx as i } from "react/jsx-runtime";
import { createStyles as d, rem as n, Badge as c } from "@mantine/core";
const g = d((s) => ({
  root: {
    borderRadius: s.radius.xs,
    fontSize: s.fontSizes.sm,
    height: n(24),
    lineHeight: 1,
    padding: `${s.spacing.sm} ${s.spacing.md}`
  }
})), p = ({ children: s, className: o, classNames: r, color: e, variant: t = "filled" }) => {
  const { classes: a } = g();
  return i(c, { className: o, classNames: {
    root: a.root,
    ...r
  }, color: e, variant: t, children: s });
};
export {
  p as Badge
};
